import React from 'react';
import RescueChipModule from './RescueChipModule';
import RescueTestimonials from './RescueTestimonials';

/**
 * Ordered list of the below-fold blocks that only the rescue adoption variant renders. Both sit
 * outside the product-details container: that is what lets the chip module's dark panel run edge to
 * edge, and it puts the testimonials directly beneath the objection they answer.
 */
export default function RescueSections() {
  return (
    <>
      <RescueChipModule />
      <RescueTestimonials />
    </>
  );
}
